import * as Sentry from '@sentry/nextjs';

export interface ErrorContext {
  module: string;
  operation: string;
  user?: { id?: number; email?: string; username?: string };
  extra?: Record<string, unknown>;
}

export function captureError(error: unknown, context: ErrorContext): void {
  Sentry.withScope((scope) => {
    scope.setTag('module', context.module);
    scope.setTag('operation', context.operation);

    if (context.user) {
      scope.setUser({
        id: context.user.id?.toString(),
        email: context.user.email,
        username: context.user.username,
      });
    }

    if (context.extra) {
      for (const [key, value] of Object.entries(context.extra)) {
        scope.setExtra(key, value);
      }
    }

    Sentry.captureException(error);
  });
}
